import * as React from "react";
import {
    Box,
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    styled,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { apiRequest } from "../../api/ApiCall";
import { useUserContext } from "../../user-provider";
import { useUtilityContext } from "../../utility-provider";
import { LOCAL_CONSTANT } from "../Const";
import { userLogging } from "../../utility/firestore";
import { decryptQueryParam } from "../../utility/util";
import { setLongPageParamObj } from "../../features/longPageSlice";
import {
    setDeficiencyComment,
    updateCell,
    updateCellSave,
} from "../../features/deficiencyCommentSlice";
import {
    initCommentData,
    deleteCommentData,
    callApi,
} from "../subPage/DeficiencyComment/DeficiencyCommentFunction";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import { 
    setTableLogicName,
    setColumnLogicName
} from "../Common";
import { DeficiencyCommentList } from "../../data/type";

export interface resultDialogProps {
    props: {
        width: number;
        height: number;
    };
}

//スタイル
const TableHeadCell = styled(TableCell)({
    textAlign: "center",
    backgroundColor: "#00CC5B",
    color: "#fff",
    border: "solid 1px rgba(224, 224, 224, 1)",
});
const DataTableCell = styled(TableCell)({
    border: "solid 1px rgba(224, 224, 224, 1)",
    paddingTop: "8px",
    paddingBottom: "8px",
    fontSize: "0.875rem",
});
const DataTableCommentCell = styled(TableCell)({
    border: "solid px rgba(224, 224, 224, 1)",
    padding: "0px",
    fontSize: "0.875rem",
});

const DeficiencyComment: React.FC<resultDialogProps> = ({ props }) => {
    //ユーザー種別を格納
    const [userType, setUserType] = useState("");
    const user = useUserContext();
    const utilityCtx = useUtilityContext();

    //不備コメント
    const listDeficiencyComment = useAppSelector((state) => state.deficiencyComment);

    //候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    const dispatch = useAppDispatch();

    //ローディングフラグ
    const [loadingFlg, setLodingFlg] = useState(false);

    //UPLパラメーター復号化してから候補地NOと枝番保存
    useEffect(() => {
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            dispatch(
                setLongPageParamObj({
                    ...objLongPageParam,
                    planAreaId: res[0],
                    branch: res[1],
                })
            );
        }).catch((e:any) => {
            console.log(e);
        });
    }, []);

    //不備コメント一覧を取得
    useEffect(() => {
        setLodingFlg(true); //ローディング開始
        if(objLongPageParam.planAreaId !== "" && objLongPageParam.branch !== ""){
            try {
                callApi("getDeficiencyComment", objLongPageParam.planAreaId, objLongPageParam.branch).then((res: any) => {
                    if (res.length > 0) {
                        dispatch(setDeficiencyComment(initCommentData(res)));
                    }
                    setLodingFlg(false); //ローディング完了
                });
            } catch (e) {
                console.log(e);
                setLodingFlg(false); //ローディング完了
            }
        }
    }, [objLongPageParam]);

    //テキストフィールドのスタイル
    const InputCommentSx = (index: number) => {
        return {
            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                paddingTop: "23px",
                paddingBottom: "23px",
                fontSize: "0.875rem",
            },
        };
    };

    //鉛筆ボタンをクリックしてでテキストフィールドコメント編集可能 キャンセルと更新ボタンを表示
    const handleEditChange = (id: number) => {
        const updateCommentTableData = [...listDeficiencyComment];
        dispatch(
            updateCell({
                ...updateCommentTableData[id],
                id: id,
                edit_status: false,
            })
        ); //編集可能
    };

    //テキストフィールド入力イベント
    const handleCellChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        id: number
    ) => {
        const updateCommentTableData = [...listDeficiencyComment];
        dispatch(
            updateCell({
                ...updateCommentTableData[id],
                id: id,
                comment: e.target.value,
            })
        );
    };

    //キャンセルボタンで鉛筆アイコンを表示
    const handleEditCancel = (id: number) => {
        const updateCommentTableData = [...listDeficiencyComment];
        dispatch(
            updateCell({
                ...updateCommentTableData[id],
                id: id,
                comment: listDeficiencyComment[id].init_comment, //コメント戻し
                edit_status: true, //編集不可
            })
        );
    };

    //コメント更新
    const handleCommentUpdateSave = (id: number) => {
        const updateCommentTableData = [...listDeficiencyComment];
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/update-comment",
            query: {
                uuid: listDeficiencyComment[id].uuid,
                comment: listDeficiencyComment[id].comment
            },
        };
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.COMMENT_UPDATE,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                    dispatch(
                        updateCellSave({
                            ...updateCommentTableData[id],
                            id: id,
                            edit_status: true, //編集不可
                            comment: listDeficiencyComment[id].comment,
                        })
                    );
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                    dispatch(
                        updateCellSave({
                            ...updateCommentTableData[id],
                            id: id,
                            edit_status: true, //編集不可
                            comment: listDeficiencyComment[id].comment,
                        })
                    );
                }
            }
        })();
    };

    //不備コメントステータスが0の場合、コメント行ごと削除
    const handleDeleteChange = (id: number) => {
        const updateCommentTableData = listDeficiencyComment.filter(
            (row) => row.id !== id
        ); //選択したid以外を返す
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/delete",
            query: {
                uuid: listDeficiencyComment[id].uuid
            },
        };
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.COMMENT_DELETE,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                    dispatch(
                        setDeficiencyComment(
                            deleteCommentData(updateCommentTableData)
                        )
                    );
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                    dispatch(
                        setDeficiencyComment(
                            deleteCommentData(updateCommentTableData)
                        )
                    );
                }
            }
        })();
    };

    const setPageName = (item: DeficiencyCommentList) => {
        // 影響度の場合は、影響度と店名を表示させる
        if (item.table_name === LOCAL_CONSTANT.TABLE.IMPACT && item.sub_key.includes("tenpo_name")) {
            const subKey = JSON.parse(item.sub_key)
            return <>{setTableLogicName(item.table_name, item.column_name)}<br />{subKey.tenpo_name}</>;
        } else {
            return setTableLogicName(item.table_name, item.column_name)
        }
    };

    //ユーザー取得
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    return (
        <Box>
            <Grid container>
                <Grid item xs={12} sx={{ height: "48px" }} />
            </Grid>
            <Grid container direction={"row"} sx={{ position: "fixed" }}>
                <Grid item sx={{ width: "55px", height: props.height }} />
                <Grid
                    item
                    sx={{
                        width: props.width,
                        height: props.height,
                        overflowY: "scroll",
                    }}
                >
                    <Box
                        sx={{ position: "relative", zIndex: 10, width: "97%" }}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <h3 style={{ marginLeft: "25px" }}>
                                    {LOCAL_CONSTANT.LABEL.LIST_OF_INCOMPLETE_COMMENTS}
                                </h3>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} sx={{ marginLeft: "25px" }}>
                            <Grid item xs={12}>
                                <TableContainer>
                                    <Table sx={{ width: "100%" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableHeadCell sx={{ width: "9%" }}>{LOCAL_CONSTANT.LABEL.NEW_FLAG}</TableHeadCell>
                                                <TableHeadCell sx={{ width: "9%" }}>{LOCAL_CONSTANT.LABEL.DATE}</TableHeadCell>
                                                <TableHeadCell sx={{ width: "13%" }}>{LOCAL_CONSTANT.LABEL.PAGE}</TableHeadCell>
                                                <TableHeadCell sx={{ width: "17%" }}>{LOCAL_CONSTANT.LABEL.ITEM}</TableHeadCell>
                                                <TableHeadCell sx={{ width: "33%" }}>{LOCAL_CONSTANT.LABEL.COMMENT}</TableHeadCell>    
                                                <TableHeadCell
                                                    sx={{
                                                        backgroundColor: "white",
                                                        border: "none",
                                                        width: "19%"
                                                    }}
                                                ></TableHeadCell>
                                            </TableRow>
                                        </TableHead>
                                        {/* ローディング中 */}
                                        {loadingFlg ? (
                                            <TableBody>
                                                <TableCell sx={{ border: "none" }}></TableCell>
                                                <TableCell sx={{ border: "none" }}></TableCell>
                                                <TableCell sx={{ textAlign: "center", border: "none" }}>
                                                    {<CircularProgress />}
                                                </TableCell>
                                                <TableCell sx={{ border: "none" }}></TableCell>
                                                {/* リサーチのみ鉛筆とゴミ箱のアイコン列を表示 */}
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <TableCell sx={{ border: "none" }}></TableCell>
                                                )}
                                            </TableBody>
                                        ) : (
                                            // ローディング完了
                                            <TableBody>
                                                {listDeficiencyComment.map(
                                                    (item, index) => (
                                                        <TableRow key={index}>
                                                            {/* deficiency_statusが0、1の時のみ「NEW」と表示する */}
                                                            {item.deficiency_status === "0" || item.deficiency_status === "1" ? (
                                                                <DataTableCell sx={{ textAlign: "center" }}>NEW</DataTableCell>
                                                            ) : (
                                                                <DataTableCell>{item.flg}</DataTableCell>
                                                            )}
                                                            <DataTableCell>{item.create_date}</DataTableCell>
                                                            <DataTableCell>{setPageName(item)}</DataTableCell>
                                                            <DataTableCell>{setColumnLogicName(item.table_name, item.column_name)}</DataTableCell>
                                                            <DataTableCommentCell>
                                                                {item.edit_status === true && (
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled={item.edit_status}
                                                                        variant="outlined"
                                                                        sx={InputCommentSx(index)}
                                                                        value={item.comment}
                                                                    />
                                                                )}
                                                                {item.edit_status === false && (
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled={item.edit_status}
                                                                        variant="outlined"
                                                                        sx={InputCommentSx(index)}
                                                                        value={item.comment}
                                                                        onChange={(e) => handleCellChange(e, index)}
                                                                    />
                                                                )}
                                                            </DataTableCommentCell>
                                                            {/* リサーチのみ鉛筆とゴミ箱のアイコン列を表示 */}
                                                            {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                                <DataTableCell sx={{ border: "none" }}
                                                                >
                                                                    {item.edit_status === true && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            onClick={() => handleEditChange(index)}
                                                                        >
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {/* 鉛筆アイコンをクリックしたらキャンセルと更新ボタンを表示 */}
                                                                    {item.edit_status === false && (
                                                                        <Button
                                                                            variant="outlined"
                                                                            sx={{ margin: "6px" }}
                                                                            color="error"
                                                                            size="small"
                                                                            onClick={() => handleEditCancel(index)}
                                                                        >
                                                                            {LOCAL_CONSTANT.LABEL.CANCEL}
                                                                        </Button>
                                                                    )}
                                                                    {item.edit_status === false && (
                                                                        <Button
                                                                            variant="contained"
                                                                            sx={{ margin: "6px" }}
                                                                            color="success"
                                                                            size="small"
                                                                            onClick={() => handleCommentUpdateSave(index)}
                                                                        >
                                                                            {LOCAL_CONSTANT.LABEL.UPDATE}
                                                                        </Button>
                                                                    )}
                                                                    {/* 不備コメントステータスが0の時のみ、鉛筆マークの右にゴミ箱マーク */}
                                                                    {item.deficiency_status ==="0" && (
                                                                        <IconButton
                                                                            sx={{
                                                                                color: "black",
                                                                                margin: "3px",
                                                                                padding: "0px"
                                                                            }}
                                                                            onClick={() => handleDeleteChange(index)}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    )}
                                                                </DataTableCell>
                                                            )}
                                                        </TableRow>
                                                    )
                                                )}
                                            </TableBody>
                                        )}
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DeficiencyComment;
